import { render } from "./DatasourceEdit.vue?vue&type=template&id=f0fc0fda"
import script from "./DatasourceEdit.vue?vue&type=script&lang=js"
export * from "./DatasourceEdit.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/pages/DatasourceEdit.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "f0fc0fda"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('f0fc0fda', __exports__)) {
    api.reload('f0fc0fda', __exports__)
  }
  
  module.hot.accept("./DatasourceEdit.vue?vue&type=template&id=f0fc0fda", () => {
    api.rerender('f0fc0fda', render)
  })

}


export default __exports__